<pre>
  {{ widgetTreeService.globals() | flatten | json }} 
</pre>
